import { api } from "@/api/axios.ts";
import {
  ApiOrganizationList,
  ApiOrganizationListItem,
  ApiOrganizationListType,
  ApiOrganizationListUpdatePayload,
} from "@/types/organization-list.types.ts";

export const apiOrganizationLists = {
  getByType: async function (type: ApiOrganizationListType) {
    return api.get<ApiOrganizationList>(`/api/v1/organization-lists/type/${type}`);
  },
  getById: async function (listId: number) {
    return api.get<ApiOrganizationList>(`/api/v1/organization-lists/${listId}`);
  },
  getItems: async function (listId: number) {
    return api.get<ApiOrganizationListItem[]>(`/api/v1/organization-lists/${listId}/items`);
  },
  update: async function (listId: number, payload: ApiOrganizationListUpdatePayload) {
    return api.put<ApiOrganizationList>(`/api/v1/organization-lists/${listId}`, payload);
  },
};
